/* EMOTION LIBRARY B版：壁の本棚をドラッグで歩く。
   ドラッグ（慣性つき）・ホイール・矢印キーで動く。
   ラベルを選んだときの窓と気分の絞り込みは el-library.js が受け持つ。 */
(() => {
  "use strict";
  const hall = document.querySelector(".el-hall");
  if (!hall) return;
  const vpEl = hall.querySelector(".el-viewport"), wall = hall.querySelector(".el-wall");
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  let x = 0, y = 0, vx = 0, vy = 0, raf = 0, drag = null, moved = 0;

  const bounds = () => {
    const W = vpEl.clientWidth, H = vpEl.clientHeight, w = wall.offsetWidth, h = wall.offsetHeight;
    return { minX: Math.min(0, W - w), maxX: 0, minY: Math.min(0, H - h), maxY: 0, W, H, w, h };
  };
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  // 端の外は抵抗をかけて少しだけ行ける
  const rubber = (v, a, b) => (v < a ? a + (v - a) * 0.3 : v > b ? b + (v - b) * 0.3 : v);

  const paint = () => {
    wall.style.transform = `translate3d(${x.toFixed(1)}px,${y.toFixed(1)}px,0)`;
  };
  const walked = () => hall.classList.add("is-walked");

  const glide = () => {
    const B = bounds();
    if (!drag) {
      x += vx; y += vy; vx *= 0.93; vy *= 0.93;
      // 端を越えていたらばねで戻す
      if (x < B.minX) { x += (B.minX - x) * 0.18; vx *= 0.5; } else if (x > B.maxX) { x += (B.maxX - x) * 0.18; vx *= 0.5; }
      if (y < B.minY) { y += (B.minY - y) * 0.18; vy *= 0.5; } else if (y > B.maxY) { y += (B.maxY - y) * 0.18; vy *= 0.5; }
      paint();
      const out = x < B.minX - .5 || x > B.maxX + .5 || y < B.minY - .5 || y > B.maxY + .5;
      if (Math.abs(vx) > .1 || Math.abs(vy) > .1 || out) { raf = requestAnimationFrame(glide); return; }
    }
    raf = 0;
  };
  const kick = () => { if (!raf) raf = requestAnimationFrame(glide); };

  // なめらかに目的地へ（キー操作・見取り図・フォーカス）
  const goTo = (tx, ty) => {
    const B = bounds();
    tx = clamp(tx, B.minX, B.maxX); ty = clamp(ty, B.minY, B.maxY);
    cancelAnimationFrame(raf); raf = 0; vx = vy = 0;
    if (reduce) { x = tx; y = ty; paint(); return; }
    const step = () => {
      x += (tx - x) * 0.16; y += (ty - y) * 0.16; paint();
      if (Math.abs(tx - x) + Math.abs(ty - y) > 0.6) raf = requestAnimationFrame(step); else { x = tx; y = ty; paint(); raf = 0; }
    };
    raf = requestAnimationFrame(step);
  };
  // 壁の左上からの位置（transform の影響を受けない）
  const pos = (el) => { const r = el.getBoundingClientRect(), w = wall.getBoundingClientRect(); return { l: r.left - w.left, t: r.top - w.top, w: r.width, h: r.height }; };
  const center = (el) => {
    const B = bounds(), p = pos(el);
    goTo(B.W / 2 - p.l - p.w / 2, B.H / 2 - p.t - p.h / 2);
  };

  vpEl.addEventListener("pointerdown", (e) => {
    if (e.button !== 0) return;
    cancelAnimationFrame(raf); raf = 0;
    drag = { id: e.pointerId, sx: e.clientX, sy: e.clientY, x0: x, y0: y, lx: e.clientX, ly: e.clientY, t: performance.now() };
    moved = 0; vx = vy = 0;
  });
  vpEl.addEventListener("pointermove", (e) => {
    if (!drag || e.pointerId !== drag.id) return;
    const dx = e.clientX - drag.sx, dy = e.clientY - drag.sy;
    moved = Math.max(moved, Math.abs(dx) + Math.abs(dy));
    if (moved > 6 && !vpEl.hasPointerCapture(e.pointerId)) { vpEl.setPointerCapture(e.pointerId); vpEl.classList.add("is-drag"); walked(); }
    const B = bounds(), now = performance.now(), dt = Math.max(1, now - drag.t);
    vx = (e.clientX - drag.lx) / dt * 16; vy = (e.clientY - drag.ly) / dt * 16;
    drag.lx = e.clientX; drag.ly = e.clientY; drag.t = now;
    x = rubber(drag.x0 + dx, B.minX, B.maxX); y = rubber(drag.y0 + dy, B.minY, B.maxY);
    paint();
  });
  const end = (e) => {
    if (!drag || e.pointerId !== drag.id) return;
    if (performance.now() - drag.t > 80) vx = vy = 0; // 止めてから離したら滑らせない
    drag = null; vpEl.classList.remove("is-drag");
    kick();
  };
  vpEl.addEventListener("pointerup", end);
  vpEl.addEventListener("pointercancel", end);
  // ドラッグしたあとの指離しで瓶が開かないようにする
  vpEl.addEventListener("click", (e) => { if (moved > 6) { e.stopPropagation(); e.preventDefault(); } }, true);

  // ホイール：壁の端に着いたら、そのままページのスクロールに渡す
  vpEl.addEventListener("wheel", (e) => {
    const B = bounds();
    let dx = e.deltaX, dy = e.deltaY;
    if (e.shiftKey && !dx) { dx = dy; dy = 0; }
    const nx = clamp(x - dx, B.minX, B.maxX), ny = clamp(y - dy, B.minY, B.maxY);
    if (nx === x && ny === y) return;
    e.preventDefault(); cancelAnimationFrame(raf); raf = 0; vx = vy = 0;
    x = nx; y = ny; paint(); walked();
  }, { passive: false });

  vpEl.addEventListener("keydown", (e) => {
    const k = { ArrowLeft: [1, 0], ArrowRight: [-1, 0], ArrowUp: [0, 1], ArrowDown: [0, -1] }[e.key];
    if (!k || e.target !== vpEl) return;
    e.preventDefault(); walked();
    goTo(x + k[0] * 320, y + k[1] * 240);
  });
  // Tab で瓶に移ったら、その瓶が見える所まで歩く
  wall.addEventListener("focusin", (e) => { const b = e.target.closest(".el-face"); if (b && !drag) center(b); });

  // 最初は左上（一つ目の気分の段の頭）を正面に置く
  const start = () => { x = 0; y = 0; paint(); };
  // 気分の札を選んだら、その段まで歩く（絞り込みそのものは el-library.js）
  hall.querySelector(".el-pick")?.addEventListener("click", (e) => {
    const b = e.target.closest("button[data-night]"); if (!b) return;
    walked();
    if (b.dataset.night === "all") return goTo(0, 0);
    const row = wall.querySelector(`.el-mrow[data-night="${b.dataset.night}"]`);
    if (row) { const p = pos(row); goTo(-p.l + 20, -p.t + 150); }
  });
  // 段ごとに少しずつ遅らせて中身を降ろす
  wall.querySelectorAll(".el-items").forEach((it, i) => [...it.children].forEach((c, j) => c.style.setProperty("--d", ((i % 4) * 0.12 + j * 0.05).toFixed(2))));
  start();
  requestAnimationFrame(() => wall.classList.add("is-in"));
  addEventListener("resize", () => { x = clamp(x, bounds().minX, 0); y = clamp(y, bounds().minY, 0); paint(); });
  setTimeout(walked, 6000);
})();
